module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti@2-46458d06fa8f1f7ef15517727e2da267.jpg";